module.exports = __webpack_public_path__ + "static/reinventing-nature-2012-5d333c19bb61a6eaddfef0122a69ade0.jpg";